import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import BrandForm from "../../components/Brand/BrandForm/BrandForm";
import Paginator from '../../components/Paginator/Paginator';
import VariantForm from '../../components/Variant/VariantForm/VariantForm'
import EditVariant from '../../components/Variant/EditVariant/EditVariant'
import AttributeColor from '../../components/Variant/Attribute/AttributeColor/AttributeColor'
import AttributeSize from '../../components/Variant/Attribute/AttributeSize/AttributeSize'

import "./CreateVariant.css";

const options = ["سایز",
                 "رنگ", 
                 "بدون رنگ یا سایز" ];

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  enTitle: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  description: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 70 })],
  },
  origin: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
  image: {
    value: "",
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [required],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class CreateVariant extends Component {
  constructor(props) {
    super(props);

    this.state = {

      sizes: [],
      colors: [],
      warranties: [],
      isEditSection: [],
      product: {},
      category: {},
      variantsLoading: true,
      variants: [],
      variantSuccess: false,

      addVariantList: [],


      tableData: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      
    };
  }

  componentDidMount() {
    this.setState({ variantsLoading: true });
    const productCode = this.props.match.params.productCode;
    const graphqlQuery = {
      query: `query productVariantData($productCode: Int!) {
          productVariant(productCode: $productCode) {
            product {
              id
              code
              status
              model
              isActive
              persianTitle
              englishTitle
              package_length
              package_width
              package_height
              package_weight
              description
              dataTheme
              length
              width
              height
              weight
              mainImageUrl
            }
            category {
              id
              code
              name
              secondName
              enName
              dataTheme
            }
            variants{
              id
              code
              title
              dataTheme
              lead_time
              order_limit
              marketable_stock
              reference_price
              price
              foreign_price
              foreign_price_isActive
              package_length
              package_width
              package_height
              package_weight
              isActive
              isDeleted
              productId
              sizeId
              colorId
              warrantyId
              color{
                title
                hexCode  
              }
              size{
                title
              }
              warranty{
                title
                period
              }
            }
            colors{
              id
              title
              hexCode
              isActive      
            },
            sizes{
              id
              title
              sort
              isActive
            },
            warranties{
              id
              title
              period
              description
              isActive
            }
          }
        }
      `,
      variables: {
        productCode: parseInt(productCode)
      }
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.props.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        console.log(resData);
        if (resData.errors) {
          throw new Error('خطا در دریافت اطلاعات محصول!');
        }

        if (resData.data.productVariant.sizes.length!=0) {
          resData.data.productVariant.sizes.forEach(size => {
            let count = 0;
            resData.data.productVariant.variants.forEach(variant => {
              variant.size.title === size.title && count++;
            });
            size.count = count;
          });          
        }
        
        if (resData.data.productVariant.colors.length!=0) {
          resData.data.productVariant.colors.forEach(color => {
            let count = 0;
            resData.data.productVariant.variants.forEach(variant => {
              variant.color.hexCode === color.hexCode && count++;
            });
            color.count = count;
          });        
        }
        
        this.setState({
          product: resData.data.productVariant.product,
          category: resData.data.productVariant.category,
          variants: resData.data.productVariant.variants,
          sizes: resData.data.productVariant.sizes,
          colors: resData.data.productVariant.colors,
          warranties: resData.data.productVariant.warranties,
          isEditSection: new Array(resData.data.productVariant.variants.length).fill(false),
          variantsLoading: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  loadVariant = (data) => {
    const Index = this.state.variants.findIndex((p) => p.id === data.id);

    const previousVariants = [...this.state.variants];
    previousVariants[Index].lead_time = data.lead_time;
    previousVariants[Index].order_limit = data.order_limit;
    previousVariants[Index].marketable_stock = data.marketable_stock;
    previousVariants[Index].reference_price = data.reference_price;
    previousVariants[Index].price = data.price;
    previousVariants[Index].foreign_price = data.foreign_price;
    previousVariants[Index].foreign_price_isActive = data.foreign_price_isActive;
    previousVariants[Index].package_length = data.package_length;
    previousVariants[Index].package_width = data.package_width;
    previousVariants[Index].package_height = data.package_height;
    previousVariants[Index].package_weight = data.package_weight;
    previousVariants[Index].isActive = data.isActive;
    
    this.setState({
      variants: previousVariants
    });
  };

  toggleVariantClass = (data) => {
    const previousIsEditSection = [...this.state.isEditSection];
    previousIsEditSection[data.index] = previousIsEditSection[data.index] ? false : true;
    
    this.setState({
      isEditSection: previousIsEditSection
    });
  };

  toggleVariantSuccessClass = () => {
    this.setState({
      variantSuccess: this.state.variantSuccess ? false : true,
    });
  };

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteBrandHandler = (data) => {
    const Index = this.props.tableData.findIndex((p) => p.code === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.props.tableData[Index].title,
    });
  };

  onEditBrandHandler = (data) => {
    const Index = this.props.tableData.findIndex((p) => p.code === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.props.tableData[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onAddVariantSizeHandler = (size) =>{
    let updatedVariantList = this.state.addVariantList;
    let last_element = updatedVariantList[updatedVariantList.length - 1];
    updatedVariantList.push({
      id: last_element=== undefined ? 1: last_element.id+1,
      sizeId: size.id,
      title: size.title,
      callAddVariant: false,
      index: size.index
    });

    let updatedSize = this.state.sizes;
    updatedSize[size.index].count +=1;

    this.setState({
      addVariantList: updatedVariantList,
      sizes: updatedSize
    });
  }

  onAddVariantColorHandler = (color) =>{
    let updatedVariantList = this.state.addVariantList;
    let last_element = updatedVariantList[updatedVariantList.length - 1];
    updatedVariantList.push({
      id: last_element=== undefined ? 1: last_element.id+1,
      colorId: color.id,
      title: color.title,
      hexCode: color.hexCode,
      callAddVariant: false,
      index: color.index
    });

    let updatedColor = this.state.colors;
    updatedColor[color.index].count +=1;

    this.setState({
      addVariantList: updatedVariantList,
      colors: updatedColor
    });
  }

  onAddVariantNoSizeNoColorHandler = () =>{
    let updatedVariantList = this.state.addVariantList;
    let last_element = updatedVariantList[updatedVariantList.length - 1];
    updatedVariantList.push({
      id: last_element=== undefined ? 1: last_element.id+1,
    });

    this.setState({
      addVariantList: updatedVariantList,
      callAddVariant: false
    });
  }

  onRemoveVariantFormHandle = (data) =>{
    let updatedVariantList = this.state.addVariantList;

    const Index = updatedVariantList.findIndex(
      (p) => p.id === data.id
    );
    if (this.state.product.dataTheme === 1) {
      let updatedSize = this.state.sizes;
      updatedSize[updatedVariantList[Index].index].count -=1;
      if (Index > -1) {
        updatedVariantList.splice(Index, 1);
      }
      this.setState({
        addVariantList: updatedVariantList,
        sizes: updatedSize
      });
    } else if(this.state.product.dataTheme === 2) {
      let updatedColor = this.state.colors;
      updatedColor[updatedVariantList[Index].index].count -=1;
      if (Index > -1) {
        updatedVariantList.splice(Index, 1);
      }
      this.setState({
        addVariantList: updatedVariantList,
        colors: updatedColor
      });
    } else {
      updatedVariantList.splice(Index, 1);
      this.setState({
        addVariantList: updatedVariantList,
      });
    }
    
  }

  createVariantSuccess = (data) =>{
    let updatedVariantList = this.state.addVariantList;

    const Index = updatedVariantList.findIndex(
      (p) => p.id === data.id
    );

    let NewVariants = [...this.state.variants];
    NewVariants.push(data.variant);
    
    if (Index > -1) {
      updatedVariantList.splice(Index, 1);
    }
    this.setState({
      addVariantList: updatedVariantList,
      variants: NewVariants
    });    
  }

  onAddVariantHandler = () =>{
    let updatedVariantList = this.state.addVariantList;

    updatedVariantList.map((variant) => (
      variant.callAddVariant=true
    ));

    this.setState({
      addVariantList: updatedVariantList,
    });
  }

  onCancelBrandHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteBrandTypeDicisionHandler = () => {
      this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteBrand(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("Deleting the post failed!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.brand];
            const postIndex = prevState.brand.findIndex(
              (p) => p.code === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              brand: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });        
  };

  onQueryHandler = (tab) => {
    const graphqlQuery = {
        query: `
        query FetchBrands($categoryCode: Int) {
            brands(categoryCode: $categoryCode){
            code
            title
            enTitle
            imageUrl
            description
            origin
            isActive
            }
        }
        `,
        variables: {
        categoryCode: this.state.parentCode.code,
        },
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            brand: resData.data.brands,
        });
           
      })
      .catch(this.catchError);
  };

  acceptBrandChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    const formData = new FormData();
    formData.append("image", postData.image);
    if (postData.oldImageUrl !== "") {
      formData.append("oldPath", postData.oldImageUrl);
    }
    fetch(process.env.REACT_APP_BACKEND_URL + "/post-image", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((fileResData) => {
        const imageUrl = fileResData.filePath || "undefined";
        let graphqlQuery;
        if (postData.editingCode !== 0) {
          if (postData.label === " برند") {
            graphqlQuery = {
              query: `
                mutation updatedBrand($code: Int!, $categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!) {
                  updateBrand(code: $code, brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                code: postData.editingCode,
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
              },
            };
          }
        } else {
          if (postData.label === " برند") {
            graphqlQuery = {
              query: `
                mutation createNewBrand($categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!) {
                  createBrand(brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
              },
            };
          }          
        }     

        return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
          method: "POST",
          body: JSON.stringify(graphqlQuery),
          headers: {
            Authorization: "Bearer " + this.props.token,
            "Content-Type": "application/json",
          },
        });
      })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createBrand";
        if (postData.editingCode !== 0) {
          resDataField = "updateBrand";          
        }

        var post = {
          code: resData.data[resDataField].code,
          title: resData.data[resDataField].title,
          enTitle: resData.data[resDataField].enTitle,
          imageUrl: resData.data[resDataField].imageUrl,
          description: resData.data[resDataField].description,
          origin: resData.data[resDataField].origin,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
            
            let updatedPosts = [...prevState.brand];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.brand.findIndex(
                (p) => p.code === post.code
              );
              updatedPosts[postIndex] = post;
            } else {
              updatedPosts.unshift(post);
            }
            return {
              brand: updatedPosts,
            };
          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editBrand: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelBrandHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelBrandHandler}
          onAcceptModal={this.onDeleteBrandTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج تنوع"
              headerDescription="نتوع کالاها را در این صفحه وارد کنید"
            />
            <Card> 
               <div className="mn-grid__row">
                    <div className="mn-grid__col">
                        <div className="mn-variant">
                            <form className="mn-variant__form" id="productVariantsForm" data-max-variants="" novalidate="novalidate">
                                <input type="hidden" name="product_variants[product_id]" value="530113"/>
                                <input type="hidden" name="product_variants[variation_theme]" value="no_color_no_size"/>
                                <div className="c-content-modal__notes"> <span className="c-content-modal__notes-title">توجه:</span>
                                    <ul className="c-content-modal__notes-list">
                                        <li>لطفاً قبل از درج تنوع، مشخصات فنی کالا (مانند: رنگ، ابعاد، اقلام همراه کالا، جنس کالا، تصویر بسته‌بندی و ...) را در سایت چک کرده و اطمینان حاصل کنید که تنوع شما با مشخصات فنی کالا در سایت مطابقت داشته باشد. عدم تطابق مشخصات فنی کالا با تنوع شما، علاوه بر ایجاد نارضایتی مشتریان و تاثیر در امتیاز عملکرد شما، موجب مرجوع شدن سفارشات به علت مغایرت شده و همچنین موجب غیر‌فعال شدن کالا/گروه کالایی خواهد شد.</li>
                                    </ul>
                                </div>
                                <div className="mn-variant-error mn-variant-error__box mt-20 mb-20 hidden"></div>
                                <div className="mn-variant__header">
                                    <div className="mn-variant__img-container">
                                        <img src={'https://api.shirazpc.com/'+this.state.product.imageUrl} alt="" className="mn-variant__img"/>
                                    </div>
                                    <div className="mn-variant__descr">
                                        <h2 className="mn-variant__title">{this.state.product.persianTitle}</h2>
                                        <div className="mn-variant__sub-title"></div>
                                        <div className="mn-variant__secondary-info mn-variant__secondary-info--top">
                                            <ul className="mn-variant__secondary-info--table">
                                                <li className="mn-variant__secondary-info--table-row">
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">دسته بندی:</span>
                                                        <span className="mn-variant__info--main">{this.state.category.secondName!==""?(this.state.category.name+" ("+this.state.category.secondName+")"):this.state.category.name}</span>
                                                    </div>
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">تنوع مجاز این کالا:</span>
                                                        <span className="mn-variant__info--main">{options[this.state.product.dataTheme-1]}</span>
                                                    </div>
                                                    {/* <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">کمیسیون فروش این کالا:</span>
                                                        <span className="mn-variant__info--main">۳٪</span>
                                                    </div> */} 
                                                </li>
                                                {this.state.product.dataTheme == 2 && (
                                                    <li className="mn-variant__secondary-info--table-row">
                                                        <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">ابعاد بسته‌بندی محصول (ارتفاع×عرض×طول):</span>
                                                            <span className="mn-variant__info--main">{this.state.product.package_length}x{this.state.product.package_width}x{this.state.product.package_height} سانتیمتر</span>
                                                        </div>
                                                        <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">وزن بسته‌بندی محصول:</span>
                                                            <span className="mn-variant__info--main">{this.state.product.package_weight} گرم</span>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="mn-variant__body" data-select2-id="26">
                                    
                                    {this.state.product.dataTheme == 1 && (
                                        <AttributeSize
                                            sizesData={this.state.sizes}
                                            onAddVariantSizeHandler={this.onAddVariantSizeHandler.bind(this)}
                                        />
                                    )}
                                    {this.state.product.dataTheme == 2 && (
                                        <AttributeColor
                                            colorsData={this.state.colors}
                                            onAddVariantColorHandler={this.onAddVariantColorHandler.bind(this)}
                                        />
                                    )}

                                    {this.state.variantSuccess && (
                                      <div className="mn-variant-error mn-variant-error__box mt-20 mb-20" id="ajaxErrorsList">
                                          <div>خطایی در ذخیره تنوع‌ها رخ داده.</div>
                                      </div>
                                    )}
                                    
                                    {this.state.variantSuccess && (
                                      <div className="mn-variant-success mn-variant-success__box mt-20 mb-20" id="ajaxSuccessList">
                                          <div>تنوع‌های شما با موفقیت ذخیره شدند</div>
                                      </div>
                                    )}
                                    
                                    {this.state.addVariantList.map((variant, index) => (
                                      <div className="mn-grid__row mn-grid__row--gap-lg mt-30">
                                          <VariantForm
                                            product={this.state.product}
                                            variant={variant}
                                            callAddVariant={variant.callAddVariant}
                                            onRemoveVariantFormHandle={this.onRemoveVariantFormHandle.bind(this)}
                                            Identifier={variant.id}
                                            warranties={this.state.warranties}
                                            variantSuccess={this.toggleVariantSuccessClass.bind(this)}
                                            createVariantSuccess={this.createVariantSuccess.bind(this)}
                                            userId={this.props.userId}
                                            token={this.props.token}
                                          />
                                      </div>
                                    ))}
                                    <div className="mn-grid__row mn-grid__row--gap-lg">
                                        <div className="mn-grid__col mn-grid__col--gap-lg">

                                            <button type="button" className={["c-ui-btn c-ui-btn--dkpc", this.state.addVariantList.length === 0 ? "hidden" : "", ].join(" ")} onClick={this.onAddVariantHandler} id="saveNewVariantsButton">افزودن به لیست تنوع</button>
                                             
                                            {this.state.product.dataTheme == 3 && (
                                              <button type="button" className="c-ui-btn c-ui-btn--add c-ui-btn--dkpc" onClick={this.onAddVariantNoSizeNoColorHandler}>افزودن تنوع جدید</button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {this.state.variants &&
                            <div className="mn-variant__form" id="productVariantsContainer">
                                <input type="hidden" className="js-static-form-data" name="search[product_id]" value="530113"/>
                                <div className="mn-grid__row js-table-container">
                                    <div className="mn-grid__col">
                                        <div className="c-variation-diversity">
                                            <div className="c-variation-diversity__header">
                                                <div className="c-variation-diversity__title">لیست تنوع ها</div>
                                                <Paginator
                                                    onNext={this.onEditHandler.bind(this)}
                                                    lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                                                    totalBrands={this.state.totalBrands}
                                                    currentPage={this.state.brandPage}
                                                />
                                            </div>
                                            <div className="c-variation-diversity__list">
                                                <table className="c-ui-table   js-search-table " data-sort-column="product_variant_id" data-sort-order="desc" data-search-url="/content/create/product/variant/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                                                    <thead>
                                                        <tr className="c-ui-table__row">
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">ردیف</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">عنوان تنوع کالا</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">عنوان گارانتی</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کد تنوع (SHPC)</span>
                                                            </th>
                                                            {/* <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کد فروشنده</span>
                                                            </th> */}
                                                            {/* <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">ارسال توسط</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کانال فروش</span>
                                                            </th> */}
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">فعال / غیرفعال</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column"></span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.variants.map((variant, index) => (
                                                        <Fragment>
                                                        <tr  className={["c-variation-diversity__item c-variation-diversity__item--top",`${this.state.isEditSection[index] && "edit"}`, ].join(" ")}>
                                                            <td className="c-variation-diversity__count">{index+1}</td>
                                                            {/* <td className="c-variation-diversity__title">{}</td> */}

                                                            <td className="c-variation-diversity__title">
                                                              <span className="mn-variant-checkbox__color" style={{backgroundColor: "#"+variant.color.hexCode }}></span>
                                                              <span className="js-variant-attribute-title">{variant.color.title}</span>
                                                            </td> 
                                                            
                                                            <td className="c-variation-diversity__warranty">{"گارانتی "+variant.warranty.period+" ماهه "+variant.warranty.title}</td>
                                                            <td className="c-variation-diversity__code">{variant.code}</td>
                                                            {/* <td className="c-variation-diversity__code js-view-supplier-code"></td>
                                                            <td>
                                                                <div className="uk-flex"> <span className="c-variation-diversity__channel dk js-view-shipping-type-digikala active"></span>
                                                                    <span className="c-variation-diversity__channel seller js-view-shipping-type-seller"></span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="uk-flex"> <span className="c-variation-diversity__channel dk js-view-site-digikala active"></span>
                                                                    <span className="c-variation-diversity__channel ds js-view-site-digistyle"></span>
                                                                </div>
                                                            </td> */}
                                                            <td className="c-variation-diversity__status js-view-active"> <span className="c-variation-diversity__status-ui js-td-active active"></span>
                                                            </td>
                                                            <td className="c-variation-diversity__action">
                                                                <button type="button" className="uk-padding-remove mn-product_link" to="/product/edit/6582800/"  onClick={this.toggleVariantClass.bind(this, {index: index,})}>
                                                                    <div className="c-mega-campaigns-join-list__container-table-btn c-mega-campaigns-join-list__container-table-btn--small-edit c-ui--mr-10 js-tool-tip-desc" aria-expanded="false"></div>
                                                                    <div className="c-rating-chart__description-tooltip c-mega-campaigns-join-list__container-table-btn-tooltip uk-text-nowrap uk-dropdown uk-dropdown-stack" uk-dropdown="boundary: .js-tool-tip-desc; pos: bottom-center;delay-hide: 0;offset: 10;" style={{left: '89.4px', top: '82.5333px'}}>ویرایش محصول</div>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr className={[ "c-variation-diversity__item c-variation-diversity__item--bottom", `${this.state.isEditSection[index] && "edit"}`, ].join(" ")}>
                                                            <td colspan="9">
                                                              <EditVariant
                                                                index={index}
                                                                variantData={variant}
                                                                toggleVariantClass={this.toggleVariantClass.bind(this)}
                                                                loadVariant={this.loadVariant.bind(this)}
                                                                userId={this.props.userId}
                                                                token={this.props.token}
                                                              />
                                                            </td>
                                                        </tr>
                                                        </Fragment>
                                                      ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="c-variation-diversity__footer">
                                                <Paginator
                                                    onNext={this.onEditHandler.bind(this)}
                                                    lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                                                    totalBrands={this.state.totalBrands}
                                                    currentPage={this.state.brandPage}
                                                />
                                            </div>
                                            <div className="c-card__loading"></div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.variantsLoading && (
                                  <div className="c-content-loader">
                                    <Newloader/>
                                  </div>
                                )} 
                                {/* <div className="c-content-loader">
                                    <div className="c-content-loader__logo"></div>
                                    <div className="c-content-loader__spinner"></div>
                                </div> */}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default CreateVariant;

